// extracted by mini-css-extract-plugin
module.exports = {"rated-all":"_3vmnA","right-rated-all":"_1d-M8","rated-all-text":"gw620","thank-text":"_3y54K"};